import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useCollectionPreviewStore } from '@/collection/stores/CollectionPreviewStore';

import CollectionPreviewGrid from './CollectionPreviewGrid/CollectionPreviewGrid';

interface CollectionPreviewProps {
  collectionId: Nullable<string>;
  containerSize: number;
  gap: number;
  isSubscription?: boolean;
  isBordered?: boolean;
  isRenderLabelExpandable?: boolean;
}

function CollectionPreview(props: CollectionPreviewProps) {
  const { collectionId, containerSize, gap, isBordered = false, isRenderLabelExpandable = true } = props;

  const { getPreviewFragments, isFetching, requestPreview } = useCollectionPreviewStore();

  useEffect(() => {
    if (collectionId) {
      requestPreview(collectionId);
    }
  }, [collectionId, requestPreview]);

  const fragments = collectionId ? (getPreviewFragments(collectionId) ?? []) : [];
  const isSkeletonShown = Boolean(collectionId && fragments.length === 0 && isFetching(collectionId));

  return (
    <CollectionPreviewGrid
      fragments={fragments}
      containerSize={containerSize}
      gap={gap}
      isBordered={isBordered}
      isSkeletonShown={isSkeletonShown}
      isRenderLabelExpandable={isRenderLabelExpandable}
    />
  );
}

export default observer(CollectionPreview);
